import {call, put, takeEvery} from 'redux-saga/effects';
import {PayloadAction} from "@reduxjs/toolkit";
import {api} from "../../api/api";
import {cardsActions, RegenerateCardPayload} from "../cards.slice";
import {CardGenerationStateDto} from "../../common";

// Only starts the generation: it runs on the server, and cardGeneration.saga
// picks the result up whether or not the user is still on the card.
function* regenerateSaga(action: PayloadAction<RegenerateCardPayload>) {
    const {cardId, text, instructions, provider} = action.payload;

    try {
        const started: CardGenerationStateDto = yield call(api.regenerateCard, {cardId, text, instructions, provider});
        yield put(cardsActions.setGeneration({cardId, generation: started.generation}));
    } catch (error) {
        window.alert(error instanceof Error ? error.message : 'Failed to regenerate card');
    }
}

export function* regenerateCardSaga() {
    yield takeEvery(cardsActions.regenerateCard.type, regenerateSaga);
}
